import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody } from "reactstrap"

const AcceptModal = ({show, onAcceptClick, onCloseClick }) => {
  return (
    <Modal size="md" isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5">
          <button type="button" onClick={onCloseClick} className="btn-close position-absolute end-0 top-0 m-3"></button>
          <p className="text-muted font-size-16 mb-4">Are you sure you want to Accept the Order ?</p>
          {/* <label className='form-label'>Date of Delivery</label>
           <br/>
          <input type='date' className='form-control'/> */}

          <div className="hstack gap-2 justify-content mb-0 mt-4">
            <button type="button" className="btn btn-primary" onClick={onAcceptClick}>Accept</button>
            <button type="button" className="btn btn-secondary" onClick={onCloseClick}>Close</button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

AcceptModal.propTypes = {
  onCloseClick: PropTypes.func,
  onAcceptClick: PropTypes.func,
  show: PropTypes.any
}

export default AcceptModal
